export { filterTypes } from '@/features/campaignsStatisticsPage/filters';
